import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RDS_DIALOG_DATA,
  RdsDialogRef,
  RdsIconsModule,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { urlValidator } from '../../../../validators';
import { RichTextEditorComponent } from '../../../shared/rich-text-editor/rich-text-editor.component';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-integration-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RichTextEditorComponent,
  ],
  templateUrl: './focus-integration-dialog.component.html',
  styleUrl: './focus-integration-dialog.component.scss',
})
export class FocusIntegrationDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusIntegrationDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    integrations?: {
      title: string;
      description: string;
      urlName: string;
      url: string;
    };
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  constructor() {
  }

  form = this._fb.group({
    title: [this.data.integrations?.title ?? '', Validators.required],
    description: [
      this.data.integrations?.description ?? '',
      [Validators.required],
    ],
    urlName: [this.data.integrations?.urlName ?? '', Validators.required],
    url: [
      this.data.integrations?.url ?? '',
      [Validators.required, urlValidator()],
    ],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
